<template>
<div class="conteudoInterno">
  <div class="boxSeta">
      <div class="setaScrollstatic" style="" 
          :class="{ 
            setaScroll: setaScrollState 
            }"
      >
        <button><span><i class="bottom"></i></span></button>
      </div> 
  </div>
  <header class="headerSec">
    <h2>Distribuição</h2>
    <div class="navSetas">
      <button @click="goBack()" :disabled="clicked"><span><i class="left"></i></span></button>
      <button @click="goNext()" :disabled="clicked"><span><i class="right"></i></span></button>
    </div> 
  </header>
  <div class="conteudoInternoBox" ref="infoBox">
    <section class="sectionRow" ref="infoscroll">
      <div class="col23ponto5 marginColBottom">
        <span class="linecol32"></span> 
      </div> 
      <div class="col32 marginColBottom">
        <div class="destDistribuicao">
          <div style="margin:0 0 20px 0;">
            <span class="titDestDist">acordos importantes com</span>
            <ul>
              <li>AMAZON VIDEO</li>
              <li>FACEBOOK</li>
              <li>GOOGLE PLAY MUSIC</li>
              <li>TIM MUSIC BY DEEZER</li>
              <li>ABRAPLEX</li>
            </ul>
          </div>
          <div class="subDestDistribuicao">
            <div>
              <span class="titDestDist">renovação<br />
                    com o
              </span>
              <span class="DestDestDist1">
                GRUPO 
                GLOBO
              </span>
            </div>
            <div>
              <span class="titDestDist">incluindo as<br />
                    plataformas digitais
              </span>
              <span class="DestDestDist2">
                TELECINE PLAY, 
                GLOBOPLAY, 
                PHILOS TV E OUTRAS
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col40ponto4">
        <p class="ptreze">O valor total distribuído pela UBC em 2018 foi de R$ 524,3 milhões. Foram contemplados na distribuição 186 mil titulares nacionais e estrangeiros, um número 25% maior do que o ano anterior.</p>
        <br />
        <p class="ptreze">Os valores distribuídos no último biênio (2018, 2017) apresentaram um crescimento de 61,9% com relação ao biênio anterior (2016, 2015). Porém, a distribuição de 2018 representou uma queda de 13,3% em relação a 2017.</p>
        <br />
        <p class="ptreze">Os valores distribuídos para os associados da UBC representaram 57% do total distribuído pelo ECAD.</p>
        <br />
        <p class="ptreze">Merece destaque a distribuição de cinema, que apresentou o maior crescimento, na ordem de 504% em relação a 2017 e, em 2018, respondeu por 7,4% do total distribuído. Este crescimento tem como principal motivo o convênio firmado com a Associação Brasileira das Empresas Exibidoras Cinematográficas Operadoras de Multiplex (Abraplex). Os valores de internet também se mantêm em crescimento acelerado (48,6%) e representaram 8,3% do total. Destacam-se a distribuição do YouTube e dos novos acordos firmados com Amazon Video e Facebook. Para os próximo anos, teremos também neste segmento a distribuição de novos contratos fechados em 2018 com Google Play Music e Tim Music by Deezer. </p>
        <br />
        <p class="ptreze">Os valores recebidos pela transmissão ou radiodifusão (TV aberta, TV por assinatura e rádio) representaram 53,7% do total distribuído.</p>
      </div><!-- col40ponto4 -->
    </section>
    <section class="sectionRow" style="margin:60px 0 0 0;">
      <div class="col23ponto5"></div> 
      <div class="col36 marginColBottom">
        <span class="titGraf2">Distribuição total da UBC em milhões (R$)</span>
        <div style="width:100%; padding:50px 0 0 0;">
            <video style="width:100%;" playsinline autoplay muted>
              <source src="../assets/grafico_distribuicao_01.mp4" type="video/mp4"> 
              Your browser does not support HTML5 video.
            </video>
          </div>
      </div>
      <div class="col36">
        <span class="titGraf2">&nbsp;</span>
        <div style="width:100%; padding:50px 0 0 0;">
            <video style="width:100%;" playsinline autoplay muted>
              <source src="../assets/grafico_distribuicao_02.mp4" type="video/mp4"> 
              Your browser does not support HTML5 video.
            </video>
          </div>
      </div>
    </section>
    <section class="sectionRow" style="margin:60px 0 0 0;">
      <div class="col23ponto5"></div> 
      <div class="col36 marginColBottom">
        <span class="titGraf2">Distribuição por tipo de titular // Execução pública de obras e fonogramas em território nacional</span>
        <div style="width:100%; padding:50px 0 0 0;">
            <video style="width:100%;" playsinline autoplay muted>
              <source src="../assets/grafico_distribuicao_03.mp4" type="video/mp4"> 
              Your browser does not support HTML5 video.
            </video>
          </div>
      </div>
      <div class="col36">
        <span class="titGraf2">Distribuição por fonte pagadora // Execução pública de obras e fonogramas em território nacional</span>
        <div style="width:100%; padding:50px 0 0 0;">
            <video style="width:100%;" playsinline autoplay muted>
              <source src="../assets/grafico_distribuicao_04.mp4" type="video/mp4"> 
              Your browser does not support HTML5 video.
            </video>
          </div>
      </div>
    </section>
    <section class="sectionRow" style="margin:60px 0 0 0;">
      <div class="col23ponto5"></div> 
      <div class="col40ponto4">
        <span class="titGraf2">Evolução das fontes pagadoras // Execução pública de obras e fonogramas em território nacional</span>
        <div style="width:100%; padding:50px 0 80px 0;">
            <video style="width:100%;" playsinline autoplay muted>
              <source src="../assets/grafico_distribuicao_05.mp4" type="video/mp4"> 
              Your browser does not support HTML5 video.
            </video>
          </div>
      </div>
      <div class="col32">
        </div>
    </section>
  </div>  
</div>
</template>

<script>
export default {
  name: 'Distribuicao',
  props:['clicked'],
  data() {
    return{
      setaScrollState: false,
    }
  },
  destroyed(){  
    this.myStopFunction();
  },
  mounted () {
    this.showSetaScroll();
  },
  methods:{
    showSetaScroll: function(){
      this.refresh = setInterval(() => {
        let alturaTela = window.innerHeight;
        let alturaDiv = this.$refs.infoBox.clientHeight;
        let boxABB = this.$refs["infoscroll"].getBoundingClientRect();
        if(alturaTela - 50 <= alturaDiv && boxABB.top == 148){
          this.setaScrollState = true
        }else{
          this.setaScrollState = false
        }
      }, 1000);
    },
    myStopFunction: function() {
      clearInterval(this.refresh);
    },
    goNext: function(){
      this.$emit("go-next");
    },
    goBack: function(){
      this.$emit("go-back");
    },  
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>


// WEBPACK FOOTER //
// src/components/Distribuicao.vue